import classNames from "classnames";
import { useEffect, useRef } from "react";

import styles from "./CitySwitcher.module.scss";

interface CitySwitcherProps {
  cities: { id: string; city: string }[];
  activeCity: string;
  setActiveCity(city: string): void;
  setProperSlide(index: number): void;
}

const CitySwitcher = ({
  cities,
  activeCity,
  setActiveCity,
  setProperSlide,
}: CitySwitcherProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const currentCityButton = containerRef.current.querySelector(
      `[data-city='${activeCity}']`
    );

    currentCityButton?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, [activeCity]);

  const cityClickHandler = (city: string) => () => {
    setActiveCity(city);
    const cityIndex = cities.findIndex((item) => item.city === city) || 0;
    setProperSlide(cityIndex);
  };

  return (
    <div className={styles.root} ref={containerRef}>
      {cities.map((city) => (
        <button
          key={city.id}
          onClick={cityClickHandler(city.city)}
          className={classNames(styles.cityButton, {
            [styles.cityButton_active]: activeCity === city.city,
          })}
          data-city={city.city}
        >
          {city.city}
        </button>
      ))}
    </div>
  );
};

export default CitySwitcher;
